import React from 'react';

export default class AddressBase extends React.Component {
  componentDidUpdate() {
    this.props.onValidity(this.formValid());
  }

  handleChange = (e) => {
    const value = e.target.name === 'postcode'
      ? e.target.value.toUpperCase().match(/[A-Z0-9\s]*/g).join('')
      : e.target.value;

    this.setState({ [e.target.name]: value || null });
    this.props.onChange({ [e.target.name]: value.trim() });
  }
}
